define(["exports", "@babel/runtime/helpers/esm/extends", "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose", "react", "styled-components"], function (_exports, _extends2, _objectWithoutPropertiesLoose2, _react, _styledComponents) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Switch = void 0;
  _exports.SwitchBase = SwitchBase;
  _extends2 = _interopRequireDefault(_extends2);
  _objectWithoutPropertiesLoose2 = _interopRequireDefault(_objectWithoutPropertiesLoose2);
  _react = _interopRequireDefault(_react);
  _styledComponents = _interopRequireWildcard(_styledComponents);
  var _excluded = ["checked", "size", "toggle", "label", "dataTestId", "disabled"];

  var Container = _styledComponents.default.label.withConfig({
    displayName: "Switch__Container",
    componentId: "sc-10x13zg-0"
  })(["cursor:pointer;display:flex;flex-direction:row;line-height:1rem;", ""], function (_ref) {
    var disabled = _ref.disabled;
    return disabled && (0, _styledComponents.css)(["cursor:default;"]);
  });

  var Label = _styledComponents.default.span.withConfig({
    displayName: "Switch__Label",
    componentId: "sc-10x13zg-1"
  })(["margin-right:10px;", ""], function (_ref2) {
    var disabled = _ref2.disabled;
    return disabled && (0, _styledComponents.css)(["color:#c8c8c8;"]);
  });

  var Input = _styledComponents.default.input.withConfig({
    displayName: "Switch__Input",
    componentId: "sc-10x13zg-2"
  })(["opacity:0;pointer-events:none;position:absolute;"]);

  var ToggleContainer = _styledComponents.default.div.withConfig({
    displayName: "Switch__ToggleContainer",
    componentId: "sc-10x13zg-3"
  })(["", ""], function (_ref3) {
    var disabled = _ref3.disabled;
    return disabled && (0, _styledComponents.css)(["background-color:#EDEDED;pointer-events:none;opacity:.5;"]);
  });

  var Toggle = _styledComponents.default.div.withConfig({
    displayName: "Switch__Toggle",
    componentId: "sc-10x13zg-4"
  })(["background-color:", ";border-radius:", ";height:", ";transform:", ";transition:", ";width:", ";"], function (_ref4) {
    var isKeyDown = _ref4.isKeyDown;
    return isKeyDown ? 'rgba(0, 0, 0, 0.3)' : '#ffffff';
  }, function (_ref5) {
    var size = _ref5.size;
    return size === 'lg' ? '10px' : '6px';
  }, function (_ref6) {
    var size = _ref6.size;
    return size === 'lg' ? '20px' : '12px';
  }, function (_ref7) {
    var checked = _ref7.checked,
        size = _ref7.size;
    return checked ? size === 'lg' ? 'translate(calc(56px - 20px - 4px))' : 'translate(calc(32px - 12px - 4px))' : 'translate(0%)';
  }, function (_ref8) {
    var theme = _ref8.theme;
    return "transform 300ms " + theme.easing.ease + ", right 2500ms " + theme.easing.ease;
  }, function (_ref9) {
    var size = _ref9.size;
    return size === 'lg' ? '20px' : '12px';
  });

  function SwitchBase(_ref10) {
    var checked = _ref10.checked,
        size = _ref10.size,
        toggle = _ref10.toggle,
        label = _ref10.label,
        dataTestId = _ref10.dataTestId,
        disabled = _ref10.disabled,
        rest = (0, _objectWithoutPropertiesLoose2.default)(_ref10, _excluded);

    var keyboardToggle = function keyboardToggle(event) {
      if (disabled) return;
      if (event.key !== ' ') return;
      event.preventDefault();
      toggle();
    };

    return /*#__PURE__*/_react.default.createElement(Container, {
      disabled: disabled
    }, /*#__PURE__*/_react.default.createElement(Label, {
      disabled: disabled
    }, label), /*#__PURE__*/_react.default.createElement(ToggleContainer, (0, _extends2.default)({
      role: "switch",
      "aria-checked": checked,
      tabIndex: "0",
      onKeyDown: keyboardToggle,
      "aria-disabled": disabled,
      disabled: disabled
    }, rest), /*#__PURE__*/_react.default.createElement(Input, {
      type: "checkbox",
      tabIndex: "-1",
      onChange: toggle,
      "data-testid": dataTestId,
      disabled: disabled
    }), /*#__PURE__*/_react.default.createElement(Toggle, {
      checked: checked,
      size: size
    })));
  }

  SwitchBase.defaultProps = {
    size: 'md'
  };
  var Switch = (0, _styledComponents.default)(SwitchBase).withConfig({
    displayName: "Switch",
    componentId: "sc-10x13zg-5"
  })(["background:", ";border-radius:", ";box-sizing:border-box;height:", ";outline:none;padding:2px;position:relative;transition:background 300ms ease;width:", ";&:focus{padding:1px;border:solid 1px ", ";box-shadow:0 0 3px 0 ", ";}"], function (_ref11) {
    var theme = _ref11.theme,
        checked = _ref11.checked;
    return checked ? "linear-gradient(to left, " + theme.colors.orange + ", #f9574b)" : theme.colors.gray;
  }, function (_ref12) {
    var size = _ref12.size;
    return size === 'lg' ? '12px' : '8px';
  }, function (_ref13) {
    var size = _ref13.size;
    return size === 'lg' ? '24px' : '16px';
  }, function (_ref14) {
    var size = _ref14.size;
    return size === 'lg' ? '56px' : '32px';
  }, function (_ref15) {
    var theme = _ref15.theme;
    return theme.colors.blue;
  }, function (_ref16) {
    var theme = _ref16.theme;
    return theme.colors.blue;
  });
  _exports.Switch = Switch;
});